import React, { useState, useEffect } from "react";

const Cookies = () => {
    const [personalization, setPersonalization] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [ads, setAds] = useState(false);

    const cookieSecurity = "security_storage";
    const cookieFunctionality = "functionality_storage";
    const cookiePersonalization = "personalization_storage";
    const cookieStorage = "analytics_storage";
    const cookieAds = "ad_storage";

    const expirationTime = 2592000 * 1000; // 30 dní v ms
    const date = new Date(Date.now() + expirationTime).toUTCString();
    const domain = `.${location.hostname.replace(/^www\./i, "")}`;

    const setCookie = (name, value) => {
        document.cookie = `${name}=${value}; SameSite=None; Secure; expires=${date}; path=/; domain=${domain}`;
    };

    const reload = () => window.location.reload();

    const saveSelected = () => {
        setCookie(cookieSecurity, "granted");
        setCookie(cookieFunctionality, "granted");
        setCookie(cookiePersonalization, personalization ? "granted" : "denied");
        setCookie(cookieStorage, analytics ? "granted" : "denied");
        setCookie(cookieAds, ads ? "granted" : "denied");
        reload();
    };

    const allowAll = () => {
        const granted = "granted";
        setCookie(cookieSecurity, granted);
        setCookie(cookieFunctionality, granted);
        setCookie(cookiePersonalization, granted);
        setCookie(cookieStorage, granted);
        setCookie(cookieAds, granted);
        reload();
    };

    const denyAll = () => {
        setCookie(cookieSecurity, "granted");
        setCookie(cookieFunctionality, "granted");
        setCookie(cookiePersonalization, "denied");
        setCookie(cookieStorage, "denied");
        setCookie(cookieAds, "denied");
        reload();
    };

    // Načtení hodnot cookies do checkboxů při otevření stránky
    useEffect(() => {
        const getCookie = (name) =>
            document.cookie
                .split("; ")
                .find((row) => row.startsWith(name + "="))
                ?.split("=")[1];

        setPersonalization(getCookie(cookiePersonalization) === "granted");
        setAnalytics(getCookie(cookieStorage) === "granted");
        setAds(getCookie(cookieAds) === "granted");
    }, []);

    return (
        <div>
            <div className="container">
                <section className="cookies setting" id="cookiesConsent">
                    <header className="cookies_header">
                        <h2>Nastavení cookies</h2>
                        <p>
                            "Cookies" jsou malé softwarové soubory, které nám umožňují ukládat
                            informace ohledně vašeho zařízení a vás jako uživatele výhradně v
                            době, kdy navštívíte některou z našich internetových stránek.
                            Cookies nám pomáhají zjistit návštěvnost našich stránek a také
                            počet jejich uživatelů. Stejně tak nám pomáhají přizpůsobit naše
                            nabídky tak, aby vyhověly vašim potřebám a byly pro Vás maximálně
                            účinné.
                        </p>
                    </header>

                    <div id="cookiesConsentForm" className="cookies_form">
                        {/* Bezpečnostní */}
                        <div className="cookies_type">
                            <div className="cookies_type_header">
                                <h3>Bezpečnostní</h3>
                            </div>
                            <p className="cookies_type_info">
                                Tyto technologie slouží k zajištění správného fungování našich
                                webových stránek a nelze je deaktivovat.
                            </p>
                            <label className="cookies_type_switch cookies_type_switch-mandatory">
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    name="security_storage"
                                    checked
                                    disabled
                                    readOnly
                                />
                                <span className="switch_el"></span>
                                Vždy aktivní
                            </label>
                        </div>

                        {/* Funkcionální */}
                        <div className="cookies_type">
                            <div className="cookies_type_header">
                                <h3>Funkcionální</h3>
                            </div>
                            <p className="cookies_type_info">
                                Tyto technologie slouží k zajištění správného fungování našich
                                webových stránek a nelze je deaktivovat.
                            </p>
                            <label className="cookies_type_switch cookies_type_switch-mandatory">
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    name="functionality_storage"
                                    checked
                                    disabled
                                    readOnly
                                />
                                <span className="switch_el"></span>
                                Vždy aktivní
                            </label>
                        </div>

                        {/* Personalizační */}
                        <div className="cookies_type">
                            <div className="cookies_type_header">
                                <h3>Personalizační</h3>
                            </div>
                            <p className="cookies_type_info">
                                Díky těmto cookies rozčleňujeme naše uživatele do různých skupin,
                                kdy každá skupina obdrží vlastní specifickou nabídku
                                služeb/produktů.
                            </p>
                            <label className="cookies_type_switch">
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    name="personalization_storage"
                                    checked={personalization}
                                    onChange={(e) => setPersonalization(e.target.checked)}
                                />
                                <span className="switch_el"></span>
                                Povolit
                            </label>
                        </div>

                        {/* Analytické */}
                        <div className="cookies_type">
                            <div className="cookies_type_header">
                                <h3>Analytické a měřící</h3>
                            </div>
                            <p className="cookies_type_info">
                                Technologie potřebné pro analýzu používáme ke zlepšení kvality
                                našich webových stránek a jejich obsahu a k zajištění správného
                                fungování vestavěných služeb našich partnerů. Zejména např. k
                                měření návštěvnosti a použitelnosti webu.
                            </p>
                            <label className="cookies_type_switch">
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    name="analytics_storage"
                                    checked={analytics}
                                    onChange={(e) => setAnalytics(e.target.checked)}
                                />
                                <span className="switch_el"></span>
                                Povolit
                            </label>
                        </div>

                        {/* Reklamní */}
                        <div className="cookies_type">
                            <div className="cookies_type_header">
                                <h3>Reklamní</h3>
                            </div>
                            <p className="cookies_type_info">
                                Tyto cookies nám umožňují lépe cílit a vyhodnocovat marketingové
                                kampaně.
                            </p>
                            <label className="cookies_type_switch">
                                <input
                                    type="checkbox"
                                    className="sr-only"
                                    name="ad_storage"
                                    checked={ads}
                                    onChange={(e) => setAds(e.target.checked)}
                                />
                                <span className="switch_el"></span>
                                Povolit
                            </label>
                        </div>

                        {/* Akce */}
                        <div className="btn-group cookies_actions">
                            <button className="bttn allow_selected" onClick={saveSelected}>
                                Uložit nastavení
                            </button>
                            <button className="bttn allow_all" onClick={allowAll}>
                                Povolit vše
                            </button>
                            <button className="bttn deny_all" onClick={denyAll}>
                                Zamítnout vše
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Cookies;
